import { render, staticRenderFns } from "./base-table-header.vue?vue&type=template&id=705a8c56"
import script from "./base-table-header.vue?vue&type=script&lang=js"
export * from "./base-table-header.vue?vue&type=script&lang=js"
import style0 from "./base-table-header.vue?vue&type=style&index=0&id=705a8c56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports